const routes = [
  {
    path:      '/atencionesporedad',
    name:      'AtencionesPorEdad',
    component: () => import('@/views/dashboards/pacientes/AtencionesPorEdad.vue'),
    meta: { title: 'Por edad',         categoria: 'Pacientes', icono: 'cake' }
  },
  {
    path:      '/atencionesporsexo',
    name:      'AtencionesPorSexo',
    component: () => import('@/views/dashboards/pacientes/AtencionesPorSexo.vue'),
    meta: { title: 'Por sexo',         categoria: 'Pacientes', icono: 'wc' }
  },
  {
    path:      '/atencionesporpaciente',
    name:      'AtencionesPorPaciente',
    component: () => import('@/views/dashboards/pacientes/AtencionesPorPaciente.vue'),
    meta: { title: 'Por paciente',     categoria: 'Pacientes', icono: 'person' }
  },
/*  
  {
    path:      '/atencionesporlocalidad',
    name:      'AtencionesPorLocalidad',
    component: () => import('@/views/dashboards/pacientes/AtencionesPorLocalidad.vue'),
    meta: { title: 'Por localidad',    categoria: 'Pacientes', icono: 'map-pin', nuevo: true }
  },
*/  
]

export { routes }